class RevealOnScroll {
  constructor() {
    this.items = document.querySelectorAll('.reveal-on-scroll');
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fadeIn');
        } else {
          entry.target.classList.remove('animate-fadeIn');
        }
      });
    });

    this.events();
  }

  events() {
    this.items.forEach(item => {
      item.classList.add('opacity-0');
      this.observer.observe(item);
    });
  }
}
export default RevealOnScroll;